import { addYear, dayEnd, monthEnd, monthStart, yearEnd, yearStart } from "@formkit/tempo";

export const PERIOD_SELECT_OPTIONS = [
  {
    label: "modals:period-select.options.this-month",
    value: "this-month",
    filter: (date) => ({ from: monthStart(date), to: monthEnd(date) }),
  },
  {
    label: "modals:period-select.options.this-year",
    value: "this-year",
    // filter: (date) => ({ from: yearStart(date), to: yearEnd(date) }),

    // Instead of using yearEnd, we use the current date, because we only want to show past shifts.
    filter: (date) => ({ from: yearStart(date), to: date }),
  },
  {
    label: "modals:period-select.options.last-year",
    value: "last-year",
    filter: (date) => ({ from: yearStart(addYear(date, -1)), to: yearEnd(addYear(date, -1)) }),
  },
  {
    label: "modals:period-select.options.all-years",
    value: "all-years",
    filter: (date) => ({ from: new Date(0), to: dayEnd(date) }),
  },
] as const satisfies ReadonlyArray<{
  label: string;
  value: string;
  filter: (date: Date) => { from: Date; to: Date };
}>;

export type PeriodSelectOption = (typeof PERIOD_SELECT_OPTIONS)[number]["value"];
